module.exports = __webpack_public_path__ + "media/effects-5.ead3f9e3.webm";